import cn from "classnames";

import { formatBankCode, maskAccountNumber } from "../wireUtils";

/**
 * "Bank account" card: bank name, masked account, bank code.
 * `bank` is a saved bank record or a pay-out snapshot (same field names).
 * `action` renders a link on the right ("Change bank details" / "Set bank details").
 */
const BankAccountCard = ({
  bank,
  action,
  emptyText = "Set up your bank details before requesting a payout.",
  className,
}) => (
  <div className={cn("bank-account-card", { empty: !bank }, className)}>
    <div className="bank-account-card-body">
      <div className="bank-account-card-title">Bank account</div>
      {bank ? (
        <div className="bank-account-card-lines">
          {bank.bankName && <span>{bank.bankName}</span>}
          {bank.accountNumber && <span>{maskAccountNumber(bank.accountNumber)}</span>}
          {bank.routingNumber && <span>{formatBankCode(bank.routingNumber)}</span>}
        </div>
      ) : (
        <div className="bank-account-card-lines">
          <span>{emptyText}</span>
        </div>
      )}
    </div>
    {action && (
      <button type="button" className="link-button bank-account-card-action" onClick={action.onClick}>
        {action.label}
      </button>
    )}
  </div>
);

export default BankAccountCard;
